export const ROUTE = {
  HOMEPAGE: '/',
  QIR: '/qir/',
  COMPLIANCE_REPORT: '/compliance-report/'
}

export const ROUTE_NAMES_WITH_PAGINATION = []

export const ROUTE_NAME = {
  HOMEPAGE: 'index',
  QIR: 'qir',
  QIR_THANK_YOU: 'qir-thank-you',
  COMPLIANCE_REPORT: 'compliance-report',
  COMPLIANCE_REPORT_THANK_YOU: 'compliance-report-thank-you'
}
